<template>
    <div class="oneLineText">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-container>
                <div class="MedicalText">
                    <el-row v-for="(item, index) in list" :key="index">
                        <el-col :xs="24" :md="13" class="companyImg">
                            <span></span>
                            <img :src="item.imgUrl" :alt="item.imgAlt">
                        </el-col>
                        <el-col :xs="24" :md="11" class="MedicalTextActive">
                            <div>
                                <h3>{{item.title}}</h3>
                                <p v-html="item.content"></p>
                                <div>
                                    <el-button size="small" plain @click="handleClick(i.linkUrl)"  v-for="(i, index1) in item.data.buttons" :key="index1" >→ {{i.text}}</el-button>
                                </div>
                                <div class="WX" v-if="item.data.qrcodeUrl">
                                    <img :src="item.data.qrcodeUrl" :alt="item.imgAlt">
                                    <p>{{item.data.qrcodeText}}</p>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-container>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        val: {}
    },
    data(){
        return{
          list: [],
            oneLineBtn:[],
            wxShow:true,
        }
    },
    methods: {
        handleClick(row) {
            window.open(row, '_self');
        }
    },
    created() {
      this.list = this.val.attaches;
    },
    watch: {
      val(val) {
        this.list = this.val.attaches;
      }
    }

}
</script>
<style lang="less" scoped>
.oneLineText{
    .MedicalText{
        border-radius: 4px;
        overflow: hidden;
        background: #f7f7f7;
        height: auto;
        width: 100%;

        .el-row{
            height: auto;
        }
        .companyImg img{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            display: block;
            height: 100%;
            width: 100%;
        }
        .el-button{
            margin-top:8px;
        }
        .el-button:hover{
            border:1px solid #eee;
            color: #d11a2e;
        }
        .el-button:focus{
            color: #d11a2e;
            border-color: #ccc;
            background-color: #f7f7f7;
        }
        .MedicalTextActive{
            padding:20px 20px 0;
            box-sizing: border-box;
            text-align: left;
            line-height: 2;
            overflow: hidden;
            min-height:280px;
            height: 100%;
            position: relative;
            box-sizing: border-box;
            h3{
                color: #d11a2e;
                font-weight: normal;
                margin: 0;
                font-size: 16px;
            }
            p{
                width: 100%;
                overflow: hidden;
                -webkit-line-clamp: 5;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                margin: 0 0 10px;
                padding: 0;
                text-align: left;
            }
            .WX{
                display: inline-block;
                position: absolute;
                right:20px;
                bottom: 15px;
                vertical-align: middle;
                text-align: center;
                font-size: 14px;
                img{
                    width: 65px;
                    margin: 0 auto;
                }
                p{
                    margin: 0;
                }
            }
        }
        .companyImg{
            span{
                position:absolute;
                right: 0;
                top:50%;
                margin-top: -10px;
                display: block;
                width: 0;
                height: 0;
                border:20px solid transparent;
                border-right-color:#f7f7f7;
            }
            img{
                width:100%;
            }
        }
    }
    @media only screen and (min-width: 768px){
        .MedicalText{
            height: 340px;
            .el-row{
                height: 100%;
            }
            .companyImg {
                height: 100%;
                img{
                    height: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch13.vue